import { useTranslation } from 'next-i18next';
import Typography from '@mui/material/Typography';
import { Layout, UploadedFile } from '@web-kc/shared/components';
import { getAirAstanaInstructionsList, useAPIQuery } from '@web-kc/core/api';
import { useApp } from '@web-kc/core/providers';

export function PagesInstructions() {
  const { t } = useTranslation();
  const isKc = useApp() === 'kc';

  const { data } = useAPIQuery(getAirAstanaInstructionsList);

  return (
    <Layout
      paths={['/', '/instructions']}
      labels={[`${t('breadcrumbs.main')}`, '']}
      pageTitle={t(`common.tenders_${isKc ? 'kc' : 'rti'}`, { ns: 'common' })}
    >
      <Typography variant="h2" mb={4}>
        {t('documents:instructionTitle')}
      </Typography>

      {data?.map((file, index) => (
        <UploadedFile
          key={index}
          file={file}
          sx={{ backgroundColor: 'white', mb: 2 }}
          downloadFunc={() => {
            const url = (file as { url?: string })?.url;
            if (url) window.open(url, '_blank');
            return Promise.resolve();
          }}
        />
      ))}
    </Layout>
  );
}
